/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Group_EditorInputs */

const en_shortcut_keys_group_editor = /** @type {(inputs: Shortcut_Keys_Group_EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editor`)
};

const fr_shortcut_keys_group_editor = /** @type {(inputs: Shortcut_Keys_Group_EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editeur`)
};

const de_shortcut_keys_group_editor = /** @type {(inputs: Shortcut_Keys_Group_EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editor`)
};

const it_shortcut_keys_group_editor = /** @type {(inputs: Shortcut_Keys_Group_EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redattore`)
};

const ru_shortcut_keys_group_editor = /** @type {(inputs: Shortcut_Keys_Group_EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Редактор`)
};

const es_shortcut_keys_group_editor = /** @type {(inputs: Shortcut_Keys_Group_EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editor`)
};

const zh_cn2_shortcut_keys_group_editor = /** @type {(inputs: Shortcut_Keys_Group_EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编辑`)
};

const ja_shortcut_keys_group_editor = /** @type {(inputs: Shortcut_Keys_Group_EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エディタ`)
};

const hi_shortcut_keys_group_editor = /** @type {(inputs: Shortcut_Keys_Group_EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संपादक`)
};

const pt_pt2_shortcut_keys_group_editor = /** @type {(inputs: Shortcut_Keys_Group_EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editor`)
};

/**
* | output |
* | --- |
* | "Editor" |
*
* @param {Shortcut_Keys_Group_EditorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_group_editor = /** @type {((inputs?: Shortcut_Keys_Group_EditorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Group_EditorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_group_editor(inputs)
	if (locale === "de") return de_shortcut_keys_group_editor(inputs)
	if (locale === "it") return it_shortcut_keys_group_editor(inputs)
	if (locale === "ru") return ru_shortcut_keys_group_editor(inputs)
	if (locale === "es") return es_shortcut_keys_group_editor(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_group_editor(inputs)
	if (locale === "ja") return ja_shortcut_keys_group_editor(inputs)
	if (locale === "hi") return hi_shortcut_keys_group_editor(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_group_editor(inputs)
	return en_shortcut_keys_group_editor(inputs)
});